import { Box, Drawer, useTheme } from '@mui/material'
import { BetValidator, FormulaKeySelector } from 'components/molecules'
import {
    BetKeyboardModal,
    BetPlanner,
    RunnerSelector
} from 'components/organisms'
import { useBetContext } from 'contexts/BetContext'

export const BetSection = () => {
    const theme = useTheme()
    const {
        selectedBetType,
        focusedInputId,
        setFocusedInputId,
        runnerSelectionVisible
    } = useBetContext()

    return (
        <>
            {selectedBetType && selectedBetType !== 'S' && (
                <Box sx={{ width: `calc(100% - ${theme.spacing(4)})` }}>
                    <FormulaKeySelector />
                </Box>
            )}
            <Box sx={{ mt: 2, width: '100%' }}>
                <BetPlanner />
            </Box>

            <BetValidator
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1
                }}
            />
            <Drawer
                anchor={'bottom'}
                open={focusedInputId !== null}
                onClose={() => setFocusedInputId(null)}
                sx={{
                    '& .MuiPaper-root': {
                        overflow: 'hidden',
                        borderTopLeftRadius: 16,
                        borderTopRightRadius: 16
                    }
                }}
            >
                <BetKeyboardModal />
            </Drawer>

            <Drawer
                open={runnerSelectionVisible}
                anchor="right"
                PaperProps={{ style: { width: '100vw' } }}
            >
                <RunnerSelector />
            </Drawer>
        </>
    )
}
